import React, { useMemo } from 'react'
import { makeTradeDialogSelector } from '../../../redux/selector'
import { useAppSelector } from '../../../redux/app'
import PositionTable from './PositionTable'

const Position = () => {
  const getTradeDialog = useMemo(makeTradeDialogSelector, [])
  const tradeDialog = useAppSelector((state) => getTradeDialog(state))

  return <PositionTable type={tradeDialog.type} />
}

export default Position